const orderLineStatuses = {
	acknowledged: 'acknowledged',
	booked: 'booked',
	cancelled: 'cancelled',
	confirmed: 'confirmed',
	created: 'created',
	delivered: 'delivered',
	entered: 'entered',
	picked: 'picked',
	refund: 'refund',
	shipped: 'shipped',
};

const orderLineStatusesForSplit = [
	orderLineStatuses.acknowledged,
	orderLineStatuses.booked,
	orderLineStatuses.confirmed,
	orderLineStatuses.created,
	orderLineStatuses.entered,
	orderLineStatuses.picked,
];

const orderStatuses = {
	canceled: "canceled",
	pending: "pending",
	unshipped: "unshipped",
	unfulfillable: "unfulfillable",
	pendingAvailability: "pending%20availability",
	shipped: "shipped",
	partiallyShipped: "partially%20shipped",
	booked: "booked",
}

const onUncancelOrderStatuses = [orderStatuses.canceled];

export { orderLineStatuses, orderLineStatusesForSplit, orderStatuses, onUncancelOrderStatuses };
